export default {
    link: {
        color: '#50b9b3'
    },
    boldLink: {
        color: '#50b9b3 !important',
        fontWeight: 'bold'
    },
    savedCardHeader: {
        background: '#50b9b3 !important'
    },
    savedCard: {
        background: '#eee'
    }
};
